export type LoyaltyBadgeCopyConfig = {
  anonymousDiscountTag?: string;
  loggedInPartialDiscountTag?: string;
};

export type LoyaltyRewardCopyConfig = {
  anonymousRewardText?: string;
  anonymousCtaText?: string;
  loggedInNoDiscountRewardText?: string;
  loggedInNoDiscountCtaText?: string;
  loggedInPartialRewardText?: string;
  loggedInPartialRewardCtaText?: string;
};

export type LoyaltyPriceTagState =
  | { status: "hidden" }
  | { status: "anonymous" }
  | { status: "partial"; discountAmount: number; discountPoints: number };

export type ProductLoyaltyBlockProps = {
  knowMoreUrl: string;
  sku: string;
  selectedQuantity?: number;
  unitPrice?: number | null;
  currency?: string;
  loyaltyRewardCopy?: LoyaltyRewardCopyConfig;
  isLoyaltyRewardCopyAuthoringEnabled?: boolean;
  onPriceTagStateChange?: (state: LoyaltyPriceTagState) => void;
};
